(function() {
  'use strict';

  angular.module('eclipseApp.core').factory('commonService', [
    'httpService',
    'downgradedUserService',
    '$http',
    'uteEndpoint',
    '$q',
    '$window',
    '$rootScope',
    '$state',
    'janrainService',
    'uteModal',
    'uteLocale',
    '$translate',
    'userPrefService',
    'permissionsService',
    'Idle',
    'env',
    'brtSwitchCMS',
    'viewInvoice',
    'BFA_CONSTANTS',
    '$location',
    'ute.datalayer.common.service',
    function(
      httpService,
      downgradedUserService,
      $http,
      uteEndpoint,
      $q,
      $window,
      $rootScope,
      $state,
      janrainService,
      uteModal,
      uteLocale,
      $translate,
      userPrefService,
      permissionsService,
      idle,
      env,
      brtSwitchCMS,
      viewInvoice,
      BFA_CONSTANTS,
      $location,
      uteDataLayerService
    ) {
      var service = {};
      var self = {};

      service.resetServiceDataDone = false;
      service.spotifyURL = '';
      service.spotifyError = '';
      service.spotifyModalSize = '';
      service.wirelessCount = 0;
      service.accountDetails = [];
      service.samKeys = [];

      service.loginFrom = '';
      service.accessToken = '';

      service.customerHasWirelessService = false;
      service.customerHasInternetService = false;
      service.customerHasTVService = false;
      service.showOnlinePromo = false;

      service.internetSubscriberNo = '';
      service.internetAccountNumber = '';
      service.internetAccountStatus = '';
      service.tvSubscriberNo = '';
      service.tvAccountNumber = '';
      service.tvAccountStatus = '';
      service.wirelessSubscriberNo = '';
      service.wirelessAccountNumber = '';
      service.wirelessAccountStatus = '';
      service.takeToProfilePage = '';
      service.deepLinkState = '';
      service.bfaDeepLinkURL = '';
      service.loginType = '';
      service.userId = '';
      service.uuid = '';
      service.profileType = '';
      service.msisdn = '';
      service.account_id = '';
      service.initialDeepLinkURL = '';
      service.firstNameLower = '';
      service.lastNameLower = '';
      service.accountOrder = '';
      service.listOfBannedWords = [];
      //to check if logout is in progress or already done
      service.loggingOut = false;
      service.loginProcessed = false;

      service.brtSwitches = [];

      var loading = false;
      self.deferred = {};

      service.logOutUser = function(confirm, loginMessage, redirectToState, isCFA) {
        console.log('inside service.logOutUser.');
        //FUSS-2661-Automatically Logout on active session expiry-Start
        if (env.sessionTimeoutEnabled) {
          //console.log('Stopped watching');
          idle.unwatch();
        }
        //FUSS-2661-Automatically Logout on active session expiry-End

        if (confirm === true) {
          self.confirmLogOut(loginMessage, redirectToState, isCFA);
        } else {
          self.logOut(loginMessage, redirectToState, isCFA);
        }
      };

      self.confirmLogOut = function(loginMessage, redirectToState, isCFA) {
        var modalConfig = {
          templateUrl: 'modules/user/views/confirm-logout.html',
          controller: [
            '$scope',
            '$modalInstance',
            function($scope, $modalInstance) {
              $scope.ok = function() {
                $modalInstance.close();
              };

              $scope.cancel = function() {
                $modalInstance.dismiss('cancel');
              };
            }
          ],
          ok: function() {
            self.logOut(loginMessage, redirectToState, isCFA);
          },
          cancel: function() {}
        };

        // show modal
        uteModal.open(modalConfig);
      };

      self.logOut = function(loginMessage, redirectToState, isCFA) {
        viewInvoice.clearList();
        var previousState = $window.localStorage.getItem('previousState');
        $window.localStorage.removeItem('previousState');
        var promise = $http({
          method: 'POST',
          url: '/bfa-api/v1/discardAllSmCookies?date=' + +new Date(),
          data: {
            applicationId: 'Fido.ca',
            ban: _.has($rootScope.userInfo, 'accounts[0].accountNumber')
              ? $rootScope.userInfo.accounts[0].accountNumber
              : ''
          }
        });

        promise
          .then(
            function() {
              return service.logOutFromServer();
            },
            function() {
              return service.logOutFromServer();
            }
          )
          .finally(function() {
            if (previousState) {
              if (previousState.indexOf('deviceCatalog') > -1) {
                $window.document.location.href = '/nac/#/choose-phone';
              } else if (previousState.indexOf('planCatalog') > -1) {
                $window.document.location.href = '/nac/#/choose-plan';
              }
            }

            $rootScope.userInfo = {};
            permissionsService.resetPermissionData();
            janrainService.clearLocalStorageValue();
            $rootScope.payment = {};

            // Clearing session data set for Prepaid Interac flow
            /*delete $scope.$storage.selectedCTN;
          delete $scope.$storage.selectedBAN;
          delete $scope.$storage.selectedRefillAmount;*/

            $.cookie.json = false;
            $.removeCookie('pageUserName', { path: '/' });
            $.removeCookie('SIGN_IN', { path: '/' });
            //$.removeCookie('lithiumSSO:fido', { path: '/' });

            // FOLLOWING LINE FROM AMIT MEHTO
            document.cookie = 'lithiumSSO:fido=; path=/; domain=.fido.ca; expires=' + new Date(0).toUTCString();
            $.cookie.json = true;

            userPrefService.clearHistory();

            service.resetServiceData();

            //Reset the counter and try to logout when janrain object is ready
            // if (!isCFA) {
            //   self.countJanrainChecks = 0;
            //   self.logOutJanrain(loginMessage, true);
            // }
            if (redirectToState === 'signin') {
              $state.go(redirectToState);
            } else if (!previousState) {
              switch (loginMessage) {
                case 'global.message.logOutMessage':
                  $window.document.location.href = env.fidoHomePageUrl;
                  break;
                case 'global.message.sessionExpiredLoginAgain':
                  $location.url('/signin?sessionExpired=true');
                  break;
              }
            }
          });
      };

      //Call logout as soon as Janrain is ready, check every 500 ms
      // self.logOutJanrain = function (loginMessage, isEasyLogin) {
      //
      //   console.log('inside self.logOutJanrain. count=' + self.countJanrainChecks);
      //
      //   setTimeout(function () {
      //     // self.countJanrainChecks += 1;
      //     if (typeof $window.janrain === 'object' && typeof $window.janrain.capture === 'object' && typeof $window.janrain.capture.ui === 'object') {
      //       console.log('self.logOutJanrain. $window.janrain.capture.ui.hasActiveSession()=' + $window.janrain.capture.ui.hasActiveSession());
      //
      //       janrainService.sessionEndReason = loginMessage;
      //
      //       if ($window.janrain.capture.ui.hasActiveSession() == true) {
      //         $window.janrain.capture.ui.endCaptureSession();
      //       }
      //
      //       if (loginMessage && !isEasyLogin) {
      //         $state.go('signin');
      //       }
      //
      //     } else {
      //       //Stop trying after failing 10 times
      //       if (self.countJanrainChecks <= 10) {
      //         self.logOutJanrain(loginMessage, isEasyLogin);
      //       } else {
      //         console.log('Exiting from self.logOutJanrain. count=' + self.countJanrainChecks);
      //       }
      //     }
      //   }, 500);
      // };

      service.getAccountDetails = function(accounts, forceReload, cacheRefreshState) {
        if (forceReload === true) {
          service.accountDetails = [];
        }

        if (loading) {
          console.log('returned loading');
          return self.deferred.promise;
        } else if ((service.accountDetails || []).length > 0 && !cacheRefreshState) {
          console.log('returned service.accountDetails', service.accountDetails);
          return $q.when(true);
        } else {
          loading = true;
        }

        var promises = [];
        self.deferred = $q.defer();

        service.resetServiceDataDone = false;
        service.samKeys = [];
        service.customerHasWirelessService = false;
        service.customerHasInternetService = false;
        service.customerHasTVService = false;

        service.internetSubscriberNo = '';
        service.internetAccountNumber = '';
        service.internetAccountStatus = '';
        service.tvSubscriberNo = '';
        service.tvAccountNumber = '';
        service.tvAccountStatus = '';
        service.wirelessSubscriberNo = '';
        service.wirelessAccountNumber = '';
        service.wirelessAccountStatus = '';
        service.wirelessPrepaid = false;

        if (!cacheRefreshState) {
          service.accountDetails = [];
        }

        _.each(accounts, function(account) {
          if (account && account.accountNumber && account.status !== 'TENTATIVE') {
            var promise = $http({
              method: 'POST',
              url: uteEndpoint('v2/accountOverview'),
              data: {
                accountNumber: account.accountNumber,
                language: uteLocale.language,
                refresh: cacheRefreshState
              }
            });
            promises.push(promise);
          } else {
            promises.push({});
          }
        });

        $q.all(promises).then(
          function(responses) {
            if (cacheRefreshState) {
              service.accountDetails = []; // if cache refresh call got success,then reset accountDetails list
            }
            _.each(responses, function(response, index) {
              var accountStatus = accounts[index].status.toUpperCase();
              // console.log('v2/accountOverview response', response);
              if (accountStatus !== 'TENTATIVE') {
                var accountDetail = {};

                if (accountStatus === 'OPEN') {
                  accountDetail.accountOrder = '1';
                } else if (accountStatus === 'SUSPENDED') {
                  accountDetail.accountOrder = '2';
                } else if (accountStatus === 'CANCELLED') {
                  accountDetail.accountOrder = '3';
                } else if (accountStatus === 'CLOSED') {
                  accountDetail.accountOrder = '4';
                }

                /* FUSS-160 Adding account status into accountdetail object to access both Account & Subscriber level status from the same object*/
                accountDetail.accountStatus = accountStatus;
                accountDetail.delinquentStatus = accounts[index].delinquentStatus;
                accountDetail.accountNumber = accounts[index].accountNumber;
                accountDetail.hasInternet = false;
                accountDetail.hasTV = false;
                accountDetail.hasWireless = false;
                if (accounts[index].serviceName === 'Internet/TV') {
                  accountDetail.hasInternet = true;
                } else if (accounts[index].serviceName === 'Wireless') {
                  accountDetail.hasWireless = true;
                  service.wirelessCount++;
                }

                /* Lithium cookie changes : START--- */
                var getCookie = function(cname) {
                  var name = cname + '=';
                  var ca = document.cookie.split(';');
                  for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1);
                    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
                  }
                  return '';
                };

                if (getCookie('lithiumSSO:fido').length < 15 || getCookie('lithiumSSO:fido') == null) {
                  if (response.data && response.data.getAccountInfo) {
                    // janrainService.checkJanrainModalReady(function () {
                    //   var UUID = janrain.capture.ui.getProfileCookieData('uuid');
                    //   /*check for easy login data*/
                    //   if (!UUID) {
                    //     var easyLoginDataJanrain = $window.localStorage.getItem('easyLoginDataJanrain');
                    //     UUID = easyLoginDataJanrain && JSON.parse(easyLoginDataJanrain).uuid;
                    //   }

                    $http({
                      method: 'POST',
                      url: uteEndpoint('v1/lithiumCookie/retrieveLithiumCookieValue'),
                      data: {
                        accountNumber: accounts[index].accountNumber,
                        uuid: $rootScope.userInfo.uuid,
                        emailAddress: response.data.getAccountInfo.primaryEmailID
                      }
                    })
                      .success(function(lithiumResponse) {
                        if (lithiumResponse.cookieVal != null && lithiumResponse.cookieVal.length > 15) {
                          //var date = new Date();
                          //var minutes = 30;
                          //date.setTime(date.getTime() + (minutes * 60 * 1000));
                          //document.cookie = "lithiumSSO:fido="+lithiumResponse.cookieVal+"; domain=.fido.ca; path=/; expires="+date.toUTCString();
                          document.cookie =
                            'lithiumSSO:fido=' + lithiumResponse.cookieVal + '; domain=.fido.ca; path=/';
                        }
                      })
                      .error(function() {
                        console.log('Inside error : retrieveLithiumCookieValue');
                      });
                    // });
                  }
                }
                /* Lithium cookie changes : END */

                if (response.data) {
                  accountDetail.cachedResultInfo = response.data.cachedResultInfo;
                  accountDetail.balance = response.data.getAccountInfo.balance;
                  accountDetail.paymentDueDate = response.data.getAccountInfo.paymentDueDate;
                  accountDetail.LOB = response.data.getAccountInfo.lob;
                  accountDetail.accountType = response.data.getAccountInfo.accountType;
                  accountDetail.accountSubType = response.data.getAccountInfo.accountSubType;
                  accountDetail.nextCycleDueIn = response.data.getAccountInfo.nextCycleDueIn;
                  accountDetail.billCycleDate = response.data.getAccountInfo.billCycleDate;
                  accountDetail.contactEmail = response.data.getAccountInfo.primaryEmailID;
                  accountDetail.MOPType = response.data.getAccountInfo.mop;
                  accountDetail.subscriberServices = [];
                  accountDetail.hasError = response.data.getAccountInfo.error;
                  accountDetail.collections = response.data.getAccountInfo.collections;
                  accountDetail.fraud = response.data.getAccountInfo.fraud;
                  accountDetail.losEnabled = response.data.getAccountInfo.losEnabled;
                  accountDetail.billingType = response.data.getAccountInfo.billingType;
                  accountDetail.billingProvince = response.data.getAccountInfo.billingProvince;
                  accountDetail.methodOfPaymentDetails = response.data.getAccountInfo.methodOfPayment;
                  accountDetail.availableCreditAmount = response.data.getAccountInfo.availableCreditAmount;
                  accountDetail.creditLimit = response.data.getAccountInfo.creditLimit;
                  accountDetail.creditLimitUsedPercentage = response.data.getAccountInfo.creditLimitUsedPercentage;
                  accountDetail.recommendedPaymentAmount = response.data.getAccountInfo.recommendedPaymentAmount;
                  accountDetail.subscriberReservedCnt = response.data.getAccountInfo.subscriberReservedCnt;
                }

                _.each(
                  (response.data && response.data.getAccountInfo && response.data.getAccountInfo.subscriberService) ||
                    [],
                  function(subscriberService) {
                    var accountSubscriberService = {
                      serviceAddress: subscriberService.serviceAddress
                    };

                    if (accounts[index].serviceName === 'Internet/TV' && accounts[index].status !== 'CANCELLED') {
                      if (
                        subscriberService &&
                        subscriberService.serviceAddress &&
                        subscriberService.serviceAddress.samKey &&
                        subscriberService.serviceAddress.samKey !== 'default'
                      ) {
                        service.samKeys.push(subscriberService.serviceAddress.samKey);
                      }
                    }

                    _.each(subscriberService.service, function(serviceData) {
                      if (serviceData.serviceName === 'Hi-Speed Internet' || serviceData.serviceName === 'HSI') {
                        accountSubscriberService.internet = serviceData;
                        service.customerHasInternetService = true;
                        service.internetSubscriberNo = serviceData.subscriberNo;
                        service.internetAccountNumber = accountDetail.accountNumber;
                        service.internetAccountStatus = accountStatus;

                        //Added as part of DSO-16764
                        if ('SUSPENDED' !== accountStatus && 'CANCELLED' !== accountStatus) {
                          $rootScope.userInfo.promoInfo = {};
                          $rootScope.userInfo.promoInfo.internetAccountNumber = accountDetail.accountNumber;
                          $rootScope.userInfo.promoInfo.internetSubscriberNo = serviceData.subscriberNo;
                        }
                      } else if (serviceData.serviceName == 'IPTV') {
                        accountSubscriberService.tv = serviceData;
                        service.customerHasTVService = (serviceData.subscriberNo || '') !== '';
                        service.tvSubscriberNo = serviceData.subscriberNo;
                        service.tvAccountNumber = accountDetail.accountNumber;
                        service.tvAccountStatus = accountStatus;
                        accountDetail.hasTV = true;
                      } else if (serviceData.serviceName == 'CTN') {
                        accountSubscriberService.wireless = serviceData;
                        service.customerHasWirelessService = true;
                        if (serviceData.firstName && serviceData.lastName) {
                          serviceData.firstNameLower = serviceData.firstName.toLowerCase();
                          serviceData.lastNameLower = serviceData.lastName.toLowerCase();
                        }
                        service.wirelessSubscriberNo = serviceData.subscriberNo;
                        service.wirelessAccountNumber = accountDetail.accountNumber;
                        service.wirelessAccountStatus = accountStatus;
                        if (accountDetail.LOB == 'WLPP') {
                          service.wirelessPrepaid = true;
                        }
                      }
                    });
                    /* condition changed for hiding ctn boxes with cancelled or suspended without los reason : to be modified by future stories */
                    if (
                      accountSubscriberService.internet ||
                      accountSubscriberService.tv ||
                      (accountSubscriberService.wireless &&
                        !(
                          accountSubscriberService.wireless.serviceName == 'CTN' &&
                          (accountSubscriberService.wireless.subscriberStatus == 'Cancelled' ||
                            (accountSubscriberService.wireless.subscriberStatus == 'Suspended' &&
                              accountSubscriberService.wireless.reason != 'LOS'))
                        ))
                    ) {
                      accountDetail.subscriberServices.push(accountSubscriberService);
                    }
                  }
                );
                service.accountDetails.push(accountDetail);
              }
            });
            console.log('old $rootScope.userPref.samKey', $rootScope.userPref.samKey);
            if ((service.samKeys || []).length > 0) {
              if ($rootScope.userPref.samKey != service.samKeys[0]) {
                $rootScope.userPref.samKey = service.samKeys[0];
              } else {
                $rootScope.$broadcast('SAMKey-Refreshed');
              }
            } else {
              $rootScope.$broadcast('SAMKey-Refreshed');
            }
            console.log('new $rootScope.userPref.samKey', $rootScope.userPref.samKey);

            self.deferred.resolve({});
            console.log('service.accountDetails', service.accountDetails);
            console.log('service.samKeys', service.samKeys);
            loading = false;
          },
          function(reason) {
            self.deferred.reject();
            console.log('Error in service.accountDetails', reason);
            loading = false;

            //if (reason.status === 401) {
            //  service.logOutUser();
            //}
          }
        );

        if (promises.length === 0) {
          console.log('Warning in service.accountDetails - No open account exist.');
          loading = false;
          self.deferred.resolve({});
        }

        return self.deferred.promise;
      };

      service.loadPaymentDetails = function(accounts) {
        var deferred = $q.defer();

        var promises = [];
        service.resetServiceDataDone = false;

        _.each(accounts, function(account) {
          if (account && account.accountNumber && account.status !== 'TENTATIVE') {
            var promise = $http({
              method: 'POST',
              url: uteEndpoint('v1/billingArrangementData'),
              data: { billingArrangementId: account.accountNumber }
            });
            promises.push(promise);
          }
        });

        $q.all(promises).then(
          function(responses) {
            _.each(responses, function(response, index) {
              console.log('v1/billingArrangementData response', response);

              var MOPType = 'invoice';
              if (response.data.methodOfPayment === 'pac') {
                MOPType = 'pac';
              } else if (response.data.methodOfPayment === 'pacc') {
                MOPType = 'pacc';
              } else if (response.data.methodOfPayment === 'invoice') {
                MOPType = 'invoice';
              }

              _.each(service.accountDetails, function(accountDetail) {
                if (accountDetail.accountNumber == accounts[index].accountNumber) {
                  accountDetail.MOPType = MOPType;
                }
              });
            });
            deferred.resolve({});
          },
          function(reason) {
            deferred.reject();
            console.log('Error in service.loadPaymentDetails', reason);
          }
        );
        return deferred.promise;
      };

      service.resetServiceData = function() {
        console.log('inside service.resetServiceData');

        service.resetServiceDataDone = true;
        loading = false;
        self.countJanrainChecks = 0;
        service.accountDetails = [];
        service.samKeys = [];
        service.loginFrom = '';
        service.accessToken = '';
        service.customerHasWirelessService = false;
        service.customerHasInternetService = false;
        service.customerHasTVService = false;
        service.internetSubscriberNo = '';
        service.internetAccountNumber = '';
        service.internetAccountStatus = '';
        service.tvSubscriberNo = '';
        service.tvAccountNumber = '';
        service.tvAccountStatus = '';
        service.wirelessSubscriberNo = '';
        service.wirelessAccountNumber = '';
        service.wirelessAccountStatus = '';
        $rootScope.atg = {};
        $rootScope.userPref.samKey = 'default';
        $rootScope.userPref.cartQuantity = 0;
        service.wirelessCount = 0;
        service.takeToProfilePage = '';
      };

      service.logOutFromServer = function() {
        // var x_session_token = $window.localStorage.getItem('x_session_token');
        // var promise = $http({
        //   method: 'POST',
        //   url: uteEndpoint('v1/logout'),
        //   data: {
        //     x_session_token: x_session_token
        //   }
        // });
        //
        // promise.then(
        //   function () {
        //     console.log('logOutFromServer success');
        //     $window.localStorage.removeItem('x_session_token');
        //   },
        //   function () {
        //     console.log('logOutFromServer fail');
        //     $window.localStorage.removeItem('x_session_token');
        //   }
        // );

        return downgradedUserService.logOut$();
      };

      //FUSS-732 Switch to online bill promo
      service.loadBillingDetails = function() {
        var paperBillingCount = 0;
        service.showOnlinePromo = false;
        _.each(service.accountDetails, function(accountDetail) {
          if (
            accountDetail.billingType &&
            accountDetail.billingType.toLowerCase() === 'paper' &&
            accountDetail.LOB &&
            accountDetail.LOB.toUpperCase() !== 'WLPP'
          ) {
            paperBillingCount++;
          }
        });

        if (paperBillingCount >= 1) {
          service.showOnlinePromo = true;
        }
        return paperBillingCount;
      };

      service.showCtnDeactivatedModal = function(error) {
        uteModal.open({
          controller: 'ctnDeactivatePopUpCtrl',
          templateUrl: 'modules/my-account/re-register/ctn-deactivate-popup.html',
          backdrop: 'static',
          keyboard: false,
          data: {
            errorCode: error
          },
          ok: function() {
            janrainService.renderLogin('', 'reload');
          },
          cancel: function() {
            janrainService.renderLogin('', 'reload');
          }
        });
      };

      service.checkCTNForBan = function(accountDetails) {
        var deferred = $q.defer();
        if (accountDetails && accountDetails.subscriberReservedCnt > 0) {
          var url = env.bfaURLs.aal.checkCTNForBan;
          var postData = {
            applicationId: BFA_CONSTANTS.APPLICATION_ID,
            accountNumber: accountDetails.accountNumber,
            activityType: 'ADD_TO_EXIST'
          };
          $http({
            method: 'POST',
            url: url,
            data: postData
          })
            .success(function(data) {
              deferred.resolve();
            })
            .error(function(data) {
              deferred.resolve();
            });
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      };

      service.checkAALEligibility = function(account) {
        var mappingKey = 'advance.mappingKey.error.add-a-line-error';
        var statusCode = '200';
        var deepLinkState = service.bfaDeepLinkURL;
        var selectedAccountDetail;
        var validWirelessAccount = false;
        //Verify the account for deeplink scenario
        if (!_.isEmpty(deepLinkState)) {
          service.bfaDeepLinkURL = '';
          if ($rootScope.userInfo && $rootScope.userInfo.profileType && $rootScope.userInfo.profileType.prepaid) {
            var inEligibleData = {
              lob: 'WLPP'
            };
            var url = '/api/selfserve/v2/accounts';
            service.trackAnalytics(url, statusCode, 'aal.message.prepaidCustomer', mappingKey);
            service.openAALInEligibilityWindow(inEligibleData);
          } else if (
            $rootScope.userInfo &&
            $rootScope.userInfo.profileType &&
            !$rootScope.userInfo.profileType.owner &&
            !$rootScope.userInfo.profileType.groupId
          ) {
            //not an account Owner
            var inEligibleData = {
              accountOwner: $rootScope.userInfo.profileType.owner
            };
            var url = '/api/selfserve/v2/accounts';
            service.trackAnalytics(url, statusCode, 'aal.message.notOwner', mappingKey);
            service.openAALInEligibilityWindow(inEligibleData);
          } else {
            var validAcctNumber;
            if (($rootScope.userInfo.accounts || []).length > 1) {
              var validAcct = _.filter($rootScope.userInfo.accounts, function(account) {
                return account.serviceName === 'Wireless' && account.status.toUpperCase() === 'OPEN';
              });
              validAcctNumber = validAcct[0].accountNumber;
            } else if (($rootScope.userInfo.accounts || []).length == 1) {
              validAcctNumber = $rootScope.userInfo.accounts[0].accountNumber;
            }
            if (!_.isEmpty(validAcctNumber)) {
              var selectedAccount = _.find(service.accountDetails, function(accountDetail) {
                return accountDetail.accountNumber === validAcctNumber;
              });
              if (selectedAccount) {
                if (selectedAccount.accountStatus.toUpperCase() !== 'OPEN') {
                  var errorCode =
                    selectedAccount.accountStatus.toUpperCase() === 'CANCELLED'
                      ? 'aal.message.notOpenStatus'
                      : selectedAccount.accountStatus.toUpperCase() === 'SUSPENDED'
                      ? 'aal.message.delinquent'
                      : '';
                  var inEligibleData = {
                    accountStatus: selectedAccount.accountStatus.toUpperCase()
                  };
                  var url = '/api/selfserve/v2/accounts';
                  service.trackAnalytics(url, statusCode, errorCode, mappingKey);
                  service.openAALInEligibilityWindow(inEligibleData);
                } else if (selectedAccount.LOB.toUpperCase() !== 'WL') {
                  var errorCode =
                    selectedAccount.LOB.toUpperCase() === 'WLPP'
                      ? 'aal.message.prepaidCustomer'
                      : selectedAccount.LOB.toUpperCase() === 'C'
                      ? 'aal.message.fhsiCustomer'
                      : '';
                  var inEligibleData = {
                    lob: selectedAccount.LOB.toUpperCase()
                  };
                  var url = '/api/selfserve/v2/accountOverview';
                  service.trackAnalytics(url, statusCode, errorCode, mappingKey);
                  service.openAALInEligibilityWindow(inEligibleData);
                } else {
                  selectedAccountDetail = selectedAccount;
                  validWirelessAccount = true;
                }
              }
            } else {
              service.trackAnalytics('', statusCode, 'aal.message.genericError', mappingKey);
              service.openAALInEligibilityWindow();
            }
          }
        } else {
          selectedAccountDetail = account;
        }
        //Clean entry || valid account exists in deeplink scenario
        if (_.isEmpty(deepLinkState) || (!_.isEmpty(deepLinkState) && validWirelessAccount)) {
          if (selectedAccountDetail && selectedAccountDetail.creditLimitUsedPercentage >= 100) {
            var inEligibleData = {
              creditLimitUsage: selectedAccountDetail.creditLimitUsedPercentage
            };
            var url = '/api/selfserve/v2/accountOverview';
            service.trackAnalytics(url, statusCode, 'aal.message.cla', mappingKey);
            service.openAALInEligibilityWindow(inEligibleData);
          } else {
            var promise = service.checkCTNForBan(selectedAccountDetail);
            promise.then(function() {
              //call checkNFDB
              $http({
                method: 'POST',
                url: '/bfa-api/v1/nac/checkNfdb',
                data: {
                  activityType: 'ADD_TO_EXIST',
                  accountNumber: selectedAccountDetail.accountNumber,
                  applicationId: 'Fido.ca'
                }
              })
                .success(function(data, status, headers, config) {
                  if (data && data.isNFDBExistInd) {
                    service.trackAnalytics(config.url, status, 'aal.message.nfdb', mappingKey);
                    service.openAALInEligibilityWindow(data);
                  } else {
                    // call checkCreditAssessment
                    $http({
                      method: 'POST',
                      url: '/bfa-api/v1/checkCreditAssessment',
                      data: {
                        lob: 'WL',
                        flow: 'ADD_TO_EXIST',
                        consolidateInd: 'NO',
                        btConvertInd: 'NO',
                        agreeToCheckCreditInd: 'YES',
                        accountNumber: selectedAccountDetail.accountNumber,
                        applicationId: 'Fido.ca'
                      }
                    })
                      .success(function(data, status, headers, config) {
                        if (data != undefined) {
                          if (
                            data.alertInd ||
                            data.fraudInd ||
                            (data.riskClass == 'IN00' && data.maxAllowedCTN == 0) ||
                            data.exitingPhoneCount + data.duplicateCTNCount >= data.maxAllowedCTN
                          ) {
                            var errorCode = data.fraudInd ? 'aal.message.fraud' : 'aal.message.creditCheck';
                            service.trackAnalytics(config.url, status, errorCode, mappingKey);
                            service.openAALInEligibilityWindow(data);
                          } else {
                            //call setCredit
                            $http({
                              method: 'POST',
                              url: '/bfa-api/v1/setCreditEvaluation',
                              data: {
                                applicationId: 'Fido.ca',
                                accountNumber: selectedAccountDetail.accountNumber
                              }
                            })
                              .success(function(data, status, headers, config) {
                                var aalEligibleData = JSON.stringify({
                                  accountNumber: selectedAccountDetail.accountNumber,
                                  billingProvince: selectedAccountDetail.billingProvince,
                                  deepLink: !_.isEmpty(deepLinkState) && validWirelessAccount,
                                  proceedToAAL: true
                                });
                                if (!_.isEmpty(deepLinkState) && validWirelessAccount) {
                                  $window.localStorage.setItem('aalEligibleData', aalEligibleData);
                                  $window.location.href = env.bfaURLs.aal.aalPageUrl;
                                } else {
                                  service.trackModalAnalytics();
                                  service.openAALInEligibilityWindow(aalEligibleData, true);
                                }
                              })
                              .error(function(data, status, headers, config) {
                                service.openAALInEligibilityWindow();
                              });
                          }
                        }
                      })
                      .error(function(data, status, headers, config) {
                        service.openAALInEligibilityWindow();
                      });
                  }
                })
                .error(function(data, status, headers, config) {
                  service.openAALInEligibilityWindow();
                });
            });
          }
        }
      };

      service.openAALInEligibilityWindow = function(aalData, disclaimerModal) {
        var windowCls = '';
        var templatePath = '';
        if (disclaimerModal) {
          windowCls = 'aal-eligibility-open-modal';
          templatePath = 'modules/my-account/add-a-line/eligible-modal.html';
        } else {
          windowCls =
            !_.isEmpty(aalData) && (aalData.isNFDBExistInd || aalData.fraudInd)
              ? 'ineligibility-pending-modal'
              : 'ineligibility-pending-modal error-highlight';
          templatePath = 'modules/my-account/add-a-line/eligibility-error-modal.html';
          if (_.isEmpty(aalData)) {
            aalData = {
              callFailure: true
            };
          }
        }

        uteModal.open({
          templateUrl: templatePath,
          controller: [
            '$scope',
            '$modalInstance',
            'data',
            '$state',
            '$window',
            'env',
            function($scope, $modalInstance, data, $state, $window, env) {
              $scope.data = data;
              $scope.enableAALTermFlow = brtSwitchCMS.brtSwitch ? brtSwitchCMS.brtSwitch.enableAALTermFlow : '';
              $scope.redirectToPage = function(pageTo) {
                $modalInstance.dismiss('cancel');
                if (pageTo === 'payment') {
                  $state.go('myAccount.payNow');
                } else if (pageTo === 'contactUs') {
                  $window.location.href = '/consumer/contact-us';
                } else if (pageTo === 'addALine') {
                  $window.localStorage.setItem('aalEligibleData', data);
                  $window.location.href = env.bfaURLs.aal.aalPageUrl;
                } else if (pageTo === 'addALineDevice') {
                  $window.localStorage.setItem('aalEligibleData', data);
                  $window.location.href = env.bfaURLs.aal.aalTermPageUrl;
                }
              };
              $scope.cancel = function() {
                $modalInstance.dismiss('cancel');
              };
            }
          ],
          windowClass: windowCls,
          backdrop: 'static',
          data: aalData
        });
      };

      service.trackAnalytics = function(url, status, errorCode, errorMappingKey, modal) {
        var payload = uteDataLayerService.getConfigByMappingKey({
          mappingKey: errorMappingKey
        });
        $translate(errorCode).then(function(errorMessage) {
          var errorType = modal
            ? $window.ute.datalayer.common.service.ErrorType.MODAL
            : $window.ute.datalayer.common.service.ErrorType.HTTP;
          var errorCategory = $window.ute.datalayer.common.service.ErrorCategory;
          var dataLayerPredefinedSection = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
          var globalObjects = [
            dataLayerPredefinedSection.ACCOUNT,
            dataLayerPredefinedSection.PAGE,
            dataLayerPredefinedSection.SITE,
            dataLayerPredefinedSection.GLOBAL
          ];
          uteDataLayerService.trackError(
            payload,
            errorType,
            status,
            errorMessage,
            errorCategory.SELF_SERVE,
            '',
            url,
            true,
            globalObjects
          );
        });
      };

      service.trackModalAnalytics = function() {
        var section = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
        const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE, section.PAGE_VIEW_EVENT];
        var mappingKey = 'advance.mappingKey.add-a-line-modal';
        var payload = uteDataLayerService.getConfigByMappingKey({
          mappingKey: mappingKey
        });
        uteDataLayerService.track(payload, true, selectedSections);
      };
      return service;
    }
  ]);
})();
